import {Component, Inject, SkipSelf} from '@angular/core';
import * as _ from 'lodash';
import {AcDialog, AcDialogComponent, DIALOG_CONFIG, DialogConfig, GeneralService, SchemaHelperService} from 'ac-infra';
import {ServerInfoService} from '../../../common/services/server-info.service';
import {MetadataService} from "../../../metadata/metadata.service";
import {TenantsRestService} from "../../services/apis/tenants-rest.service";
import {validIPv4, validIPv4Range} from "../../../../../projects/utils/shared/ip.models";

@AcDialog({
    id: 'service-dialog',
    title: 'Service Details',
    cancelButtonText: 'Close',
    width: 600,
    })
@Component({
    selector: 'network-service-dialog',
    templateUrl: './network-service-dialog.component.html',
    })
export class NetworkServiceDialogComponent {

    service: any = {};
    schema: any = {};
    isEdit;
    serviceAddSchema = require('../../../../schema/post/serviceprocessor.json');
    serviceEditSchema = require('../../../../schema/put/serviceprocessor.json');
    additionalSettings;

    licenseTypeList = [{value: 'ACM', text: 'ACM'}, {value: 'LOCAL_BREAKOUT', text: 'Local Breakout'}];

    ServerInfoService = ServerInfoService;
    lcCustomers;
    tenants;
    selectedLCCustomer;
    selectedTenant;
    type;
    serviceSourceMapper;

    constructor(@SkipSelf() private acDialogComponent: AcDialogComponent,
                @Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig,
                private tenantsRestService: TenantsRestService,
                public generalService: GeneralService)  {}

    ngOnInit() {
        this.serviceSourceMapper = MetadataService.getType('ServiceSource');
        this.service = this.dialogConfig.dialogData.entity;
        this.lcCustomers = this.dialogConfig.dialogData.lcCustomers;
        this.tenants = this.dialogConfig.dialogData.tenants;
        this.selectedLCCustomer = this.dialogConfig.dialogData.lcCustomer;
        this.selectedTenant = this.dialogConfig.dialogData.tenant;
        this.isEdit = this.dialogConfig.dialogData.isEdit;
        this.schema = _.cloneDeep(this.isEdit ? this.serviceEditSchema : this.serviceAddSchema);
        this.service.lcCustomerId = this.selectedLCCustomer?.id || this.service.lcCustomerId || this.lcCustomers?.[0]?.id;
        this.service.serviceSource = this.service.serviceSource || this.dialogConfig.dialogData.type;
        this.additionalSettings = _.cloneDeep(this.service);

        this.additionalSettings.tenantId = this.selectedTenant?.id || this.additionalSettings.tenantId || this.tenants?.[0]?.id;

        if(this.tenants?.length > 0){
            this.tenantChange(this.additionalSettings.tenantId);
        }
        this.additionalSettings.serviceType = this.serviceSourceMapper[this.service.serviceSource]?.viewName || '';
    }

    tenantChange = (tenantId) => {
        const tenant = this.tenantsRestService.getEntityById(tenantId)
        this.service.iamAccountId = tenant.iamAccountId;
    }

    validateAuxiliaryForm = (errors, auxModel, formModel) => {
        if (this.tenants?.length > 0 && !this.service.iamAccountId) {
            errors.push(SchemaHelperService.buildErrorItem({
                inputName: 'additionalSettings.tenantId',
                message: 'Tenant missing IAM Account ID'
            }));
        }
    }

}





